export const InboxesName = 'inboxesComponent';
